<template>
    <div>
        <b-modal size="xl" :id="id" ref="finder" hide-footer :title="prefix + title">
            <GrupoContratoList @close="grupoContratoSelect" :title="prefix + title + ' >'" />
        </b-modal>
        <lg-form-input-finder v-model="localValue" fieldDescription="descricao" :label="label"
            invalidFeedback="Grupo de Contrato deve ser informado!" description="" @handleClean="handleClear">
            <template #prepend>
                <b-button @click="show" class="btn-input-finder" pressed>
                    <b-icon icon="search" />
                </b-button>
            </template>
        </lg-form-input-finder>
    </div>
</template>

<script>
import GrupoContratoList from "@/modules/cadastros/grupocontrato/GrupoContratoList.vue";
import LgFormInputFinder from "@/core/components/Form/LgFormInputFinder.vue";

export default {
    name: "LgFinderPageGrupoContrato",
    components: { LgFormInputFinder, GrupoContratoList },

    props: {
        id: {
            type: String,
            default: "finderGrupoContrato",
        },
        value: Object,
        prefix: {
            type: String,
            default: "",
        },
        label: {
            type: String,
            default: "Grupo de Contrato",
        },
        title: {
            type: String,
            default: "Grupo de Contrato",
        },
    },

    data() {
        return {
            localValue: this.value,

        };
    },

    watch: {
        value(newValue) {
            this.localValue = newValue;
        },
        localValue(newValue) {
            this.$emit("input", newValue);
        },
    },

    methods: {
        async show() {
            await this.$refs.finder.show();
        },

        handleClear() {
            this.localValue = null;
            this.$emit("input", null);
        },

        grupoContratoSelect(item) {
            this.localValue = item;
            this.$emit("input", item);
            this.$refs.finder.hide();
        },
    },
};
</script>
